<template>
  <div class="card-acceptance-fields">
    <div
      v-for="card in CARD_ACCEPTANCE_CATALOG"
      :key="card.brand"
      class="card-acceptance-fields__brand"
    >
      <p class="mb-1 fw-500">{{ card.label }}</p>
      <div class="d-flex flex-wrap gap-3">
        <template v-for="funding in card.fundingTypes" :key="funding.fundingType">
          <label
            v-for="option in funding.options"
            :key="`${card.brand}-${funding.fundingType}-${option.subtype}`"
            class="form-check"
          >
            <input
              class="form-check-input"
              type="checkbox"
              :checked="isAllowed(card.brand, funding.fundingType, option.subtype)"
              :disabled="disabled"
              @change="
                toggle(
                  card.brand,
                  funding.fundingType,
                  option.subtype,
                  $event.target.checked
                )
              "
            />
            <span class="form-check-label">
              {{ option.label }}
            </span>
          </label>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CARD_ACCEPTANCE_CATALOG,
  normalizedCardAcceptance
} from '@/config/cardAcceptance';

export default {
  name: 'CardAcceptanceFields',
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return { CARD_ACCEPTANCE_CATALOG };
  },
  methods: {
    isAllowed(brand, fundingType, subtype) {
      const rule = normalizedCardAcceptance(this.modelValue).allowed_cards.find(
        (entry) =>
          entry.brand === brand && entry.funding_type === fundingType
      );
      return Boolean(rule?.allowed_subtypes.includes(subtype));
    },
    toggle(brand, fundingType, subtype, checked) {
      const cardAcceptance = normalizedCardAcceptance(this.modelValue);
      const rule = cardAcceptance.allowed_cards.find(
        (entry) =>
          entry.brand === brand && entry.funding_type === fundingType
      );

      if (checked && !rule) {
        cardAcceptance.allowed_cards.push({
          brand,
          funding_type: fundingType,
          allowed_subtypes: [subtype]
        });
      } else if (checked && !rule.allowed_subtypes.includes(subtype)) {
        rule.allowed_subtypes.push(subtype);
      } else if (!checked && rule) {
        rule.allowed_subtypes = rule.allowed_subtypes.filter(
          (currentSubtype) => currentSubtype !== subtype
        );
        if (!rule.allowed_subtypes.length) {
          cardAcceptance.allowed_cards = cardAcceptance.allowed_cards.filter(
            (entry) =>
              entry.brand !== brand || entry.funding_type !== fundingType
          );
        }
      }

      this.$emit('update:modelValue', normalizedCardAcceptance(cardAcceptance));
    }
  }
};
</script>

<style lang="scss" scoped>
.card-acceptance-fields__brand + .card-acceptance-fields__brand {
  margin-top: 0.75rem;
}
</style>
